"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.DsButtonClasses = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createStyles = require("../styles/createStyles");
var _utilities = require("../utilities");
var _responsiveProps = require("../utilities/responsiveProps");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const DsButtonClasses = exports.DsButtonClasses = {
  iconSizeXs: 'DsBtn__ixs',
  iconSizeSm: 'DsBtn__is',
  iconSizeMd: 'DsBtn__im',
  iconSizeLg: 'DsBtn__il',
  iconSizeXl: 'DsBtn__ixl',
  /* Styles applied to the root element if startIcon is supplied. */
  withStartIcon: 'DsBtn__si',
  /* Styles applied to the root element if endIcon is supplied. */
  withEndIcon: 'DsBtn__ei'
};
const fullWidthCssDefinitions = {
  fullWidth: {
    true: {
      width: '100%'
    },
    false: {
      width: 'auto'
    }
  }
};
const getSpacings = (theme, size) => {
  const {
    spacing,
    space: {
      component: {
        button
      }
    }
  } = theme.busbud;
  const btnSize = `size${(0, _utilities.capitalizeFirstWord)(size)}`;
  const {
    default: {
      x,
      y
    },
    iconLeft,
    iconRight
  } = button[btnSize].inset;
  return {
    padding: spacing(y, x),
    [`&.${DsButtonClasses.withStartIcon}`]: {
      padding: spacing(iconLeft.y, iconLeft.right, iconLeft.y, iconLeft.left)
    },
    [`&.${DsButtonClasses.withEndIcon}`]: {
      padding: spacing(iconRight.y, iconRight.right, iconRight.y, iconRight.left)
    }
  };
};
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    colors,
    fontWeight,
    styles,
    spacing,
    typography
  } = theme.busbud;
  const sizeCssDefinitions = {
    size: {
      /* Styles applied to the root element if `size="xs"`. */
      xs: _objectSpread(_objectSpread({}, typography.font.component.label.sm), {}, {
        fontWeight: fontWeight.bold,
        borderRadius: styles.rounding.sm
      }, getSpacings(theme, 'xs')),
      /* Styles applied to the root element if `size="sm"`. */
      sm: _objectSpread(_objectSpread({}, typography.font.component.label.md), {}, {
        fontWeight: fontWeight.bold,
        borderRadius: styles.rounding.md
      }, getSpacings(theme, 'sm')),
      /* Styles applied to the root element if `size="md"`. */
      md: _objectSpread(_objectSpread({}, typography.font.component.label.lg), {}, {
        fontWeight: fontWeight.bold,
        borderRadius: styles.rounding.md
      }, getSpacings(theme, 'md')),
      /* Styles applied to the root element if `size="lg"`. */
      lg: _objectSpread(_objectSpread({}, typography.font.component.label.xl), {}, {
        fontWeight: fontWeight.bold,
        borderRadius: styles.rounding.md
      }, getSpacings(theme, 'lg')),
      /* Styles applied to the root element if `size="xl"`. */
      xl: _objectSpread(_objectSpread({}, typography.font.component.label.xl), {}, {
        fontWeight: fontWeight.heavy,
        borderRadius: styles.rounding.lg
      }, getSpacings(theme, 'xl'))
    }
  };
  return _objectSpread(_objectSpread(_objectSpread({
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      color: colors.text.primary.opaque,
      '&:hover': {
        textDecoration: 'none'
      }
    },
    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  }, (0, _utils.generateVariantStyles)(theme)), {}, {
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },
    // only needed for type safety
    text: {},
    contained: {},
    textInherit: {},
    containedInherit: {},
    /* Styles applied to the root element if startIcon or endIcon is supplied. */
    withIcon: {
      textAlign: 'left'
    }
  }, (0, _responsiveProps.generateUnoptimizedResponsiveStyles)(theme, _objectSpread(_objectSpread({}, sizeCssDefinitions), fullWidthCssDefinitions))), {}, {
    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      [`&.${DsButtonClasses.iconSizeXs}`]: {
        marginRight: spacing(0.5)
      },
      [`&.${DsButtonClasses.iconSizeSm}`]: {
        marginRight: spacing(0.5)
      },
      [`&.${DsButtonClasses.iconSizeMd}`]: {
        marginRight: spacing(1)
      },
      [`&.${DsButtonClasses.iconSizeLg}`]: {
        marginRight: spacing(1)
      },
      [`&.${DsButtonClasses.iconSizeXl}`]: {
        marginRight: spacing(1)
      }
    },
    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      [`&.${DsButtonClasses.iconSizeXs}`]: {
        marginLeft: spacing(0.5)
      },
      [`&.${DsButtonClasses.iconSizeSm}`]: {
        marginLeft: spacing(0.5)
      },
      [`&.${DsButtonClasses.iconSizeMd}`]: {
        marginLeft: spacing(1)
      },
      [`&.${DsButtonClasses.iconSizeLg}`]: {
        marginLeft: spacing(1)
      },
      [`&.${DsButtonClasses.iconSizeXl}`]: {
        marginLeft: spacing(1)
      }
    }
  });
});